import { EditorView } from "@codemirror/view";

import { rangesState, trackedDeletesFromState } from "components/organisms/manuscript/adapter/ot";

export function findClickedRangeTarget(view, event) {
    const target = event?.target;
    const element = target instanceof Element ? target : target instanceof Node ? target.parentElement : null;

    if (!(element instanceof Element)) {
        return null;
    }

    const commentRange = element.closest?.("[data-range-item-id], .ol-cm-change-c");
    if (!(commentRange instanceof Element)) {
        return null;
    }

    const pos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY,
    });
    if (!Number.isFinite(pos)) {
        return null;
    }

    const ranges = view.state.field(rangesState, false);
    if (!ranges?.comments?.length) {
        return null;
    }

    const snapshotPos = trackedDeletesFromState(view.state).toSnapshot(pos);
    const comment = ranges.comments.find(
        (entry) =>
            !entry?.resolved &&
            Array.isArray(entry?.ranges) &&
            entry.ranges.some((range) => range?.containsCursor?.(snapshotPos)),
    );

    if (!comment?.id) {
        return null;
    }

    return {
        kind: "comment",
        id: String(comment.id),
        pos,
    };
}

export function rangeClickExtension(onRangeActivate) {
    if (!onRangeActivate) {
        return [];
    }

    return [
        EditorView.domEventHandlers({
            click(event, view) {
                if (event.button !== 0) {
                    return false;
                }

                if (!view.state.selection.main.empty) {
                    return false;
                }

                const rangeTarget = findClickedRangeTarget(view, event);
                if (!rangeTarget) {
                    return false;
                }

                const handled = onRangeActivate(rangeTarget, view, event);
                if (!handled) {
                    return false;
                }

                event.preventDefault();
                event.stopPropagation();
                return true;
            },
        }),
    ];
}
